import {reactive} from "vue";

export default function () {

    const bgLayoutMap = reactive({
        'none': '',
        'Rain3D': '',
        'Snow3d': '',
        'Snow': '',
        'TwistHole': '',
        'Blossom': '',
        'TimeTunnel': 'bg_layout_wrap time_tunnel_bg', // 時光隧道
        'Mandala': 'bg_layout_wrap mandala_bg', // Mandala
        'Swirl': 'bg_layout_wrap swirl_bg', // 漩渦
        'Kaleidoscope': 'bg_layout_wrap kaleidoscope_bg', // 萬花筒
        'RainbowShoot': 'bg_layout_wrap rainbowShoot_bg', // 放射彩虹
    })

    const horizontalPosition = reactive({
        Left: "horizontal-left",
        Center: "horizontal-center",
        Right: "horizontal-right"
    })

    const verticalPosition = reactive({
        Top: "vertical-top",
        Center: "vertical-center",
        Bottom: "vertical-bottom"
    })

    const columnTextAlign = reactive({
        Left: "align-items-start",
        Center: "align-items-center",
        Right: "align-items-end"
    })

    const threeSensorMainSpaceFix = reactive({
        'font_family_HyperspaceRace_BoldItalic' : '0',
        'font_family_LTCFournierLeJeune_Regular' : '7px',
        'font_family_Caprasimo_Regular' : '0',
        'font_family_ManoloMono_Regular' : '0',
        'font_family_NotoSansTC_Bold' : '0',
        'font_family_GoodTimesRg_Italic' : '21px'
    })
    const threeSensorSubSpaceFix = reactive({
        'font_family_HyperspaceRace_BoldItalic' : '0',
        'font_family_LTCFournierLeJeune_Regular' : '0',
        'font_family_Caprasimo_Regular' : '0',
        'font_family_ManoloMono_Regular' : '0',
        'font_family_NotoSansTC_Bold' : '0',
        'font_family_GoodTimesRg_Italic' : '24px'
    })
    const threeSensorMainMarginFix = reactive({
        'font_family_HyperspaceRace_BoldItalic' : '0 0 23px 0',
        'font_family_LTCFournierLeJeune_Regular' : '-9px 0 0 0',
        'font_family_Caprasimo_Regular' : '0',
        'font_family_ManoloMono_Regular' : '0',
        'font_family_NotoSansTC_Bold' : '0',
        'font_family_GoodTimesRg_Italic' : '10px 0 0 0'
    })
    const threeSensorMainPaddingFix = reactive({
        'font_family_HyperspaceRace_BoldItalic' : '0 6px 0 0',
        'font_family_LTCFournierLeJeune_Regular' : '0',
        'font_family_Caprasimo_Regular' : '0 0 0 11px',
        'font_family_ManoloMono_Regular' : '0',
        'font_family_NotoSansTC_Bold' : '0',
        'font_family_GoodTimesRg_Italic' : '0'
    })
    const threeSensorLeftPaddingFix = reactive({
        'font_family_HyperspaceRace_BoldItalic' : '0 44px 0 0',
        'font_family_LTCFournierLeJeune_Regular' : '0 28px 0 0',
        'font_family_Caprasimo_Regular' : '0 23px 0 0',
        'font_family_ManoloMono_Regular' : '0',
        'font_family_NotoSansTC_Bold' : '0',
        'font_family_GoodTimesRg_Italic' : '0 29px 0 0'
    })

    const threeSensorRightPaddingFix = reactive({
        'font_family_HyperspaceRace_BoldItalic' : '0 0 0 17px',
        'font_family_LTCFournierLeJeune_Regular' : '0 0 0 21px',
        'font_family_Caprasimo_Regular' : '0 0 0 28px',
        'font_family_ManoloMono_Regular' : '0',
        'font_family_NotoSansTC_Bold' : '0',
        'font_family_GoodTimesRg_Italic' : '0 0 0 23px'
    })


    const fourSensorLeftTopPaddingFix = reactive({
        'font_family_HyperspaceRace_BoldItalic' : '0 22px 23px 0',
        'font_family_LTCFournierLeJeune_Regular' : '0 28px 32px 0',
        'font_family_Caprasimo_Regular' : '0 23px 23px 0',
        'font_family_ManoloMono_Regular' : '0',
        'font_family_NotoSansTC_Bold' : '0 0 21px 0',
        'font_family_GoodTimesRg_Italic' : '0 29px 23px 0'
    })

    const fourSensorRightTopPaddingFix = reactive({
        'font_family_HyperspaceRace_BoldItalic' : '0 0 23px 32px',
        'font_family_LTCFournierLeJeune_Regular' : '0 0 32px 21px',
        'font_family_Caprasimo_Regular' : '0 0 23px 28px',
        'font_family_ManoloMono_Regular' : '0',
        'font_family_NotoSansTC_Bold' : '0 0 21px 0',
        'font_family_GoodTimesRg_Italic' : '0 0 23px 23px'
    })


    const fourSensorLeftBottomPaddingFix = reactive({
        'font_family_HyperspaceRace_BoldItalic' : '0 22px 0 0',
        'font_family_LTCFournierLeJeune_Regular' : '0 28px 14px 0',
        'font_family_Caprasimo_Regular' : '0 23px 6px 0',
        'font_family_ManoloMono_Regular' : '0',
        'font_family_NotoSansTC_Bold' : '0 0 18px 0',
        'font_family_GoodTimesRg_Italic' : '0 29px 16px 0'
    })

    const fourSensorRightBottomPaddingFix = reactive({
        'font_family_HyperspaceRace_BoldItalic' : '0 0px 0 32px',
        'font_family_LTCFournierLeJeune_Regular' : '0 0 14px 21px',
        'font_family_Caprasimo_Regular' : '0 0 6px 28px',
        'font_family_ManoloMono_Regular' : '0',
        'font_family_NotoSansTC_Bold' : '0 0 18px 0',
        'font_family_GoodTimesRg_Italic' : '0 0 16px 23px'
    })


    const fourSensorLeftMainFontMarginFix = reactive({
        'font_family_HyperspaceRace_BoldItalic' : '0',
        'font_family_LTCFournierLeJeune_Regular' : '0',
        'font_family_Caprasimo_Regular' : '0',
        'font_family_ManoloMono_Regular' : '0',
        'font_family_NotoSansTC_Bold' : '0',
        'font_family_GoodTimesRg_Italic' : '0 0 0 -18px'
    })
    const fourSensorLeftSubFontMarginFix = reactive({
        'font_family_HyperspaceRace_BoldItalic' : '0',
        'font_family_LTCFournierLeJeune_Regular' : '0',
        'font_family_Caprasimo_Regular' : '0',
        'font_family_ManoloMono_Regular' : '0',
        'font_family_NotoSansTC_Bold' : '0',
        'font_family_GoodTimesRg_Italic' : '0 0 0 -18px'
    })

    const fourSensorRightMainFontMarginFix = reactive({
        'font_family_HyperspaceRace_BoldItalic' : '0',
        'font_family_LTCFournierLeJeune_Regular' : '0',
        'font_family_Caprasimo_Regular' : '0',
        'font_family_ManoloMono_Regular' : '0',
        'font_family_NotoSansTC_Bold' : '0',
        'font_family_GoodTimesRg_Italic' : '0 0 0 -12px'
    })
    const fourSensorRightSubFontMarginFix = reactive({
        'font_family_HyperspaceRace_BoldItalic' : '0',
        'font_family_LTCFournierLeJeune_Regular' : '0',
        'font_family_Caprasimo_Regular' : '0',
        'font_family_ManoloMono_Regular' : '0',
        'font_family_NotoSansTC_Bold' : '0',
        'font_family_GoodTimesRg_Italic' : '0 0 0 -12px'
    })

    const fourSensorSubSpaceFix = reactive({
        'font_family_HyperspaceRace_BoldItalic' : '12px',
        'font_family_LTCFournierLeJeune_Regular' : '15px',
        'font_family_Caprasimo_Regular' : '14px',
        'font_family_ManoloMono_Regular' : '12px',
        'font_family_NotoSansTC_Bold' : '21px',
        'font_family_GoodTimesRg_Italic' : '24px'
    })

    function initMainFontFamily(mode) {
        switch (mode) {
            case 'TimeTunnel':
                return 'font_family_GoodTimesRg_Italic'
            case 'Snow':
                return 'font_family_LTCFournierLeJeune_Regular'
            case 'Mandala':
                return 'font_family_AgencyGothicCT_Bold'
            case 'Blossom':
                return 'font_family_AbrilFatface'
            case 'TwistHole':
            case 'Image':
            case 'Color':
                return 'font_family_HyperspaceRace_BoldItalic'
            case 'RainbowShoot':
                return 'font_family_ManoloMono_Regular'
            case 'Swirl':
            case 'Kaleidoscope':
                return 'font_family_Caprasimo_Regular'
            case 'TransformSpot':
                return 'font_family_Cubic11'
            case 'Rain3D':
            case 'Snow3d':
            case 'MeteorShower':
            case 'Fireworks':
            case 'none':
            default:
                return 'font_family_NotoSansTC_Bold'
        }
    }
    return {
        bgLayoutMap,
        horizontalPosition,
        verticalPosition,
        columnTextAlign,
        initMainFontFamily,
        threeSensorMainPaddingFix,
        threeSensorLeftPaddingFix,
        threeSensorRightPaddingFix,
        threeSensorMainMarginFix,
        threeSensorMainSpaceFix,
        threeSensorSubSpaceFix,
        fourSensorLeftTopPaddingFix,
        fourSensorLeftBottomPaddingFix,
        fourSensorRightTopPaddingFix,
        fourSensorRightBottomPaddingFix,
        fourSensorSubSpaceFix,
        fourSensorLeftMainFontMarginFix,
        fourSensorLeftSubFontMarginFix,
        fourSensorRightMainFontMarginFix,
        fourSensorRightSubFontMarginFix
    }
}
